export default {
    isGridOpen: state => state.gridIsOpen,
    isFormOpen: state => state.formIsOpen,
    getDataTableOptions: state => state.dataTableOptions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    getSearchFields: state => state.searchFields,
    getSearchFormActions: state => state.searchFormActions,
    getHeaderFields: state => state.headerFields,
    getFormActions: state => state.formActions,
    getPatientFormActions: state => state.patientFormActions,
    // getCustomerFormActions: state => state.customerFormActions,
    getCustomerHeaderFields: state => state.customerHeaderFields,
    getSelectCustomerRowActions: state => state.selectCustomerRowActions,
    getCustomerActions: state => state.customerActions,
    getCustomerSearchFields: state => state.customerSearchFields,
    getSelectCustomerDataTableOptions: state => state.selectCustomerDataTableOptions,
    getCustomerFormActions: state => state.customerFormActions,
    getSelectPartnerDataTableOptions: state => state.selectPartnerDataTableOptions,
    getSelectPartnerRowActions: state => state.selectPartnerRowActions,
    getSelectInsurancePartnerRowActions: state => state.selectInsurancePartnerRowActions,
    getSelectPartnerHeaderFields: state => state.selectPartnerHeaderFields,
    getPatientCompanyHeaderFields: state => state.patientCompanyHeaderFields,

    getSelectedItems: state => state.selectedItems,
    isAlreadySelected: (state) => (item) => state.selectedItems.includes(item),

}
